import { useMemo } from 'react';
import { Column } from '~/commonComponents/Column';
import { IFavoriteProfessional } from '~/domain/FavoriteProfessionals';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';
import { NoFavorite } from './NoFavorite';

export const FavoriteTabPanel = ({
  isLoading,
  selectedProfessionals,
  onSelectProfessionals,
  profession,
  data = [],
  isNewDesign,
  onViewSkills,
  allSelectableIds,
  jobId,
}: IProfessionalTabPanelProps<IFavoriteProfessional>) => {
  const professionals = useMemo(() => {
    return data?.map(
      (it) =>
        ({
          ...it,
          profile_image: it?.profileImage,
          full_name: it?.fullName,
          isFavorite: true,
          rating: {
            averageRating: it?.averageProfessionalRating?.averageRating,
            professionalSkills: it?.averageProfessionalRating?.averageProfessionalSkills,
            interpersonalSkills: it?.averageProfessionalRating?.averageInterpersonalSkills,
            timeManagement: it?.averageProfessionalRating?.averageTimeManagement,
          },
          badges: it?.badges ?? [],
          education: it?.education ?? {},
        }) as IFavoriteProfessional,
    );
  }, [data]);

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Column flex={1}>
      <ProfessionalList
        DescriptionComponent={
          <>
            Send invites to all your favorite professionals who will be
            <br />
            confirmed upon accepting the offer at the listed rate and time.
          </>
        }
        EmptyComponent={<NoFavorite />}
        isEmpty={isEmpty}
        isLoading={isLoading}
        // @ts-expect-error -- Wrong type
        professionals={professionals}
        selectedProfessionals={selectedProfessionals}
        selectedProfession={profession}
        onSelectProfessionals={onSelectProfessionals}
        isNewDesign={isNewDesign}
        onViewSkills={onViewSkills}
        allSelectableIds={allSelectableIds}
        jobId={jobId}
      />
    </Column>
  );
};
